import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";

const InfoText =({ max, text, icon, stylus=null, clases=null, })=> {

    const [ show, seShow ] = useState(text.length<max);

    return  <p style={{...stylus, zIndex:1, borderRadius:'7px', border:show&&text.length>max?'dashed 1px #edf2f9':'none'}} className={`overflow-hidden ${show&&text.length>max&&'d-flex align-items-center bg-white p-1'} text-detail-post ${clases&&clases}`}>
                
                {icon&&<FontAwesomeIcon icon={icon}/>}
                
                {show&&text?text:text.substr(0,max)+'...'}
                
                {text&&text.length>max&&
                
                <span data-toggle="tooltip" title={text} style={{cursor:'pointer'}} onClick={()=>seShow(!show)} className='m-0 mx-1 badge badge-light badge-pill text-secundary mx-1'>
                    {show?'Ver menos':'Ver más'}
                </span>}
            
            </p>
}
export default InfoText;